"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStyleDefinition = exports.defaultBoundary = void 0;
exports.defaultBoundary = [
    {
        lat: 22.310582,
        lng: 114.018618,
    },
    {
        lat: 22.312483,
        lng: 114.018388,
    },
    {
        lat: 22.311848,
        lng: 114.009118,
    },
    {
        lat: 22.300929000000004,
        lng: 114.006929,
    },
    {
        lat: 22.290129,
        lng: 114.00281,
    },
    {
        lat: 22.285523,
        lng: 113.991866,
    },
    {
        lat: 22.283537000000003,
        lng: 113.991823,
    },
    {
        lat: 22.281869,
        lng: 114.001308,
    },
    {
        lat: 22.277302,
        lng: 114.010491,
    },
    {
        lat: 22.276872999999995,
        lng: 114.021944,
    },
    {
        lat: 22.27762,
        lng: 114.022081,
    },
    {
        lat: 22.277685,
        lng: 114.022113,
    },
    {
        lat: 22.277766,
        lng: 114.022151,
    },
    {
        lat: 22.277821000000003,
        lng: 114.022218,
    },
    {
        lat: 22.277856000000003,
        lng: 114.022277,
    },
    {
        lat: 22.277901,
        lng: 114.02232,
    },
    {
        lat: 22.277938,
        lng: 114.022349,
    },
    {
        lat: 22.277973,
        lng: 114.022363,
    },
    {
        lat: 22.278037,
        lng: 114.022358,
    },
    {
        lat: 22.278092,
        lng: 114.022371,
    },
    {
        lat: 22.278146,
        lng: 114.022422,
    },
    {
        lat: 22.278193000000005,
        lng: 114.022465,
    },
    {
        lat: 22.278236,
        lng: 114.022508,
    },
    {
        lat: 22.278236,
        lng: 114.022588,
    },
    {
        lat: 22.278241,
        lng: 114.022717,
    },
    {
        lat: 22.278246,
        lng: 114.022781,
    },
    {
        lat: 22.278256,
        lng: 114.022824,
    },
    {
        lat: 22.278238,
        lng: 114.022891,
    },
    {
        lat: 22.278201,
        lng: 114.023001,
    },
    {
        lat: 22.278166,
        lng: 114.023106,
    },
    {
        lat: 22.278164,
        lng: 114.023197,
    },
    {
        lat: 22.278189000000005,
        lng: 114.023291,
    },
    {
        lat: 22.278206,
        lng: 114.023377,
    },
    {
        lat: 22.278206,
        lng: 114.023468,
    },
    {
        lat: 22.278211,
        lng: 114.023581,
    },
    {
        lat: 22.278233,
        lng: 114.023693,
    },
    {
        lat: 22.278257999999997,
        lng: 114.023755,
    },
    {
        lat: 22.27829,
        lng: 114.023811,
    },
    {
        lat: 22.278315,
        lng: 114.023852,
    },
    {
        lat: 22.278359999999996,
        lng: 114.023878,
    },
    {
        lat: 22.278394,
        lng: 114.02386,
    },
    {
        lat: 22.278456,
        lng: 114.023825,
    },
    {
        lat: 22.278524,
        lng: 114.023811,
    },
    {
        lat: 22.278561,
        lng: 114.023819,
    },
    {
        lat: 22.278601,
        lng: 114.02386,
    },
    {
        lat: 22.27865,
        lng: 114.023924,
    },
    {
        lat: 22.27867,
        lng: 114.02397,
    },
    {
        lat: 22.278697,
        lng: 114.023972,
    },
    {
        lat: 22.278727000000003,
        lng: 114.023951,
    },
    {
        lat: 22.278767,
        lng: 114.023894,
    },
    {
        lat: 22.278792,
        lng: 114.023835,
    },
    {
        lat: 22.278830999999997,
        lng: 114.02376,
    },
    {
        lat: 22.278866,
        lng: 114.023648,
    },
    {
        lat: 22.278896000000003,
        lng: 114.023589,
    },
    {
        lat: 22.278923,
        lng: 114.023551,
    },
    {
        lat: 22.278955,
        lng: 114.023532,
    },
    {
        lat: 22.279010000000003,
        lng: 114.023479,
    },
    {
        lat: 22.279045,
        lng: 114.023428,
    },
    {
        lat: 22.279072,
        lng: 114.023385,
    },
    {
        lat: 22.279134000000003,
        lng: 114.023353,
    },
    {
        lat: 22.279196,
        lng: 114.023307,
    },
    {
        lat: 22.279246,
        lng: 114.023269,
    },
    {
        lat: 22.279288,
        lng: 114.023259,
    },
    {
        lat: 22.279325,
        lng: 114.02326100000002,
    },
    {
        lat: 22.27936,
        lng: 114.023286,
    },
    {
        lat: 22.279406999999996,
        lng: 114.023288,
    },
    {
        lat: 22.279442000000003,
        lng: 114.023286,
    },
    {
        lat: 22.279469,
        lng: 114.02326100000002,
    },
    {
        lat: 22.279487000000003,
        lng: 114.023229,
    },
    {
        lat: 22.279492,
        lng: 114.023194,
    },
    {
        lat: 22.279492000000005,
        lng: 114.023157,
    },
    {
        lat: 22.279511000000003,
        lng: 114.023127,
    },
    {
        lat: 22.279558,
        lng: 114.023111,
    },
    {
        lat: 22.279621,
        lng: 114.023074,
    },
    {
        lat: 22.279680000000003,
        lng: 114.023023,
    },
    {
        lat: 22.27975,
        lng: 114.022977,
    },
    {
        lat: 22.279802,
        lng: 114.022953,
    },
    {
        lat: 22.279842,
        lng: 114.022894,
    },
    {
        lat: 22.279894,
        lng: 114.022824,
    },
    {
        lat: 22.279938,
        lng: 114.022749,
    },
    {
        lat: 22.279995,
        lng: 114.022693,
    },
    {
        lat: 22.280049999999996,
        lng: 114.022671,
    },
    {
        lat: 22.280139,
        lng: 114.022655,
    },
    {
        lat: 22.280241,
        lng: 114.022639,
    },
    {
        lat: 22.280318,
        lng: 114.022618,
    },
    {
        lat: 22.280394999999995,
        lng: 114.022591,
    },
    {
        lat: 22.280467,
        lng: 114.022534,
    },
    {
        lat: 22.280584,
        lng: 114.02247,
    },
    {
        lat: 22.280656,
        lng: 114.022441,
    },
    {
        lat: 22.280752,
        lng: 114.022435,
    },
    {
        lat: 22.280847,
        lng: 114.022441,
    },
    {
        lat: 22.280947999999995,
        lng: 114.022427,
    },
    {
        lat: 22.281035000000003,
        lng: 114.022406,
    },
    {
        lat: 22.28113,
        lng: 114.022374,
    },
    {
        lat: 22.281189,
        lng: 114.022366,
    },
    {
        lat: 22.281231,
        lng: 114.022355,
    },
    {
        lat: 22.281281,
        lng: 114.022355,
    },
    {
        lat: 22.281311,
        lng: 114.022368,
    },
    {
        lat: 22.281437000000004,
        lng: 114.022419,
    },
    {
        lat: 22.281497,
        lng: 114.022449,
    },
    {
        lat: 22.281532,
        lng: 114.022449,
    },
    {
        lat: 22.281579,
        lng: 114.022457,
    },
    {
        lat: 22.281611,
        lng: 114.022497,
    },
    {
        lat: 22.281631,
        lng: 114.02254,
    },
    {
        lat: 22.281646,
        lng: 114.022588,
    },
    {
        lat: 22.281688,
        lng: 114.022626,
    },
    {
        lat: 22.28172,
        lng: 114.022647,
    },
    {
        lat: 22.281755,
        lng: 114.022634,
    },
    {
        lat: 22.2818,
        lng: 114.022604,
    },
    {
        lat: 22.281872,
        lng: 114.02258,
    },
    {
        lat: 22.281971,
        lng: 114.022542,
    },
    {
        lat: 22.282078,
        lng: 114.022494,
    },
    {
        lat: 22.28218,
        lng: 114.022451,
    },
    {
        lat: 22.282259,
        lng: 114.022449,
    },
    {
        lat: 22.282393,
        lng: 114.022449,
    },
    {
        lat: 22.282522,
        lng: 114.022454,
    },
    {
        lat: 22.282634,
        lng: 114.022481,
    },
    {
        lat: 22.28273,
        lng: 114.022513,
    },
    {
        lat: 22.282807,
        lng: 114.022526,
    },
    {
        lat: 22.282951,
        lng: 114.022534,
    },
    {
        lat: 22.283048,
        lng: 114.022548,
    },
    {
        lat: 22.283110000000004,
        lng: 114.022583,
    },
    {
        lat: 22.283146999999996,
        lng: 114.022634,
    },
    {
        lat: 22.283195,
        lng: 114.02269,
    },
    {
        lat: 22.283222,
        lng: 114.022754,
    },
    {
        lat: 22.283264000000003,
        lng: 114.022787,
    },
    {
        lat: 22.283308999999996,
        lng: 114.022819,
    },
    {
        lat: 22.283375999999997,
        lng: 114.02284,
    },
    {
        lat: 22.283433,
        lng: 114.022864,
    },
    {
        lat: 22.283475,
        lng: 114.022894,
    },
    {
        lat: 22.2835,
        lng: 114.022934,
    },
    {
        lat: 22.283544,
        lng: 114.022937,
    },
    {
        lat: 22.283584,
        lng: 114.022942,
    },
    {
        lat: 22.283631,
        lng: 114.022966,
    },
    {
        lat: 22.283666,
        lng: 114.022993,
    },
    {
        lat: 22.283691,
        lng: 114.023028,
    },
    {
        lat: 22.283726000000005,
        lng: 114.023052,
    },
    {
        lat: 22.28377,
        lng: 114.023055,
    },
    {
        lat: 22.283825,
        lng: 114.02306,
    },
    {
        lat: 22.283855,
        lng: 114.023058,
    },
    {
        lat: 22.283883999999997,
        lng: 114.023036,
    },
    {
        lat: 22.283926999999995,
        lng: 114.023012,
    },
    {
        lat: 22.283971000000005,
        lng: 114.023001,
    },
    {
        lat: 22.284013999999996,
        lng: 114.023004,
    },
    {
        lat: 22.284072999999996,
        lng: 114.023012,
    },
    {
        lat: 22.284118,
        lng: 114.023015,
    },
    {
        lat: 22.284144999999995,
        lng: 114.023001,
    },
    {
        lat: 22.28418,
        lng: 114.022977,
    },
    {
        lat: 22.284220000000005,
        lng: 114.022953,
    },
    {
        lat: 22.284262,
        lng: 114.02296400000002,
    },
    {
        lat: 22.284294000000003,
        lng: 114.02299,
    },
    {
        lat: 22.284324,
        lng: 114.023004,
    },
    {
        lat: 22.284383,
        lng: 114.023007,
    },
    {
        lat: 22.284432999999996,
        lng: 114.023004,
    },
    {
        lat: 22.284463,
        lng: 114.022982,
    },
    {
        lat: 22.284495,
        lng: 114.022953,
    },
    {
        lat: 22.284525,
        lng: 114.022929,
    },
    {
        lat: 22.284555000000005,
        lng: 114.022918,
    },
    {
        lat: 22.28458,
        lng: 114.022934,
    },
    {
        lat: 22.284607,
        lng: 114.022948,
    },
    {
        lat: 22.284644,
        lng: 114.022926,
    },
    {
        lat: 22.284669000000005,
        lng: 114.022883,
    },
    {
        lat: 22.284695999999997,
        lng: 114.022832,
    },
    {
        lat: 22.284711,
        lng: 114.022789,
    },
    {
        lat: 22.284741,
        lng: 114.022738,
    },
    {
        lat: 22.2848,
        lng: 114.022642,
    },
    {
        lat: 22.284838000000004,
        lng: 114.02256900000002,
    },
    {
        lat: 22.28486,
        lng: 114.0225,
    },
    {
        lat: 22.284877,
        lng: 114.022414,
    },
    {
        lat: 22.284875000000003,
        lng: 114.022339,
    },
    {
        lat: 22.284875,
        lng: 114.022239,
    },
    {
        lat: 22.284845,
        lng: 114.022111,
    },
    {
        lat: 22.284815,
        lng: 114.022028,
    },
    {
        lat: 22.284818,
        lng: 114.021963,
    },
    {
        lat: 22.284835,
        lng: 114.021888,
    },
    {
        lat: 22.284867,
        lng: 114.021826,
    },
    {
        lat: 22.28488,
        lng: 114.021775,
    },
    {
        lat: 22.28487,
        lng: 114.021743,
    },
    {
        lat: 22.28485,
        lng: 114.021682,
    },
    {
        lat: 22.284823,
        lng: 114.021633,
    },
    {
        lat: 22.284788,
        lng: 114.021601,
    },
    {
        lat: 22.284746,
        lng: 114.021566,
    },
    {
        lat: 22.284718000000005,
        lng: 114.021534,
    },
    {
        lat: 22.284700999999995,
        lng: 114.021499,
    },
    {
        lat: 22.284686000000004,
        lng: 114.021416,
    },
    {
        lat: 22.284666,
        lng: 114.021311,
    },
    {
        lat: 22.284659,
        lng: 114.021236,
    },
    {
        lat: 22.284671000000003,
        lng: 114.021161,
    },
    {
        lat: 22.284909999999996,
        lng: 114.02074,
    },
    {
        lat: 22.285371,
        lng: 114.020287,
    },
    {
        lat: 22.285495000000004,
        lng: 114.02019,
    },
    {
        lat: 22.285545,
        lng: 114.020134,
    },
    {
        lat: 22.285575,
        lng: 114.020086,
    },
    {
        lat: 22.285604,
        lng: 114.019986,
    },
    {
        lat: 22.285629000000004,
        lng: 114.019847,
    },
    {
        lat: 22.285664000000004,
        lng: 114.019769,
    },
    {
        lat: 22.285696,
        lng: 114.019721,
    },
    {
        lat: 22.285731,
        lng: 114.019651,
    },
    {
        lat: 22.285927,
        lng: 114.019536,
    },
    {
        lat: 22.286150000000003,
        lng: 114.019418,
    },
    {
        lat: 22.286366,
        lng: 114.01931,
    },
    {
        lat: 22.286436,
        lng: 114.019286,
    },
    {
        lat: 22.286808,
        lng: 114.019166,
    },
    {
        lat: 22.287228,
        lng: 114.019048,
    },
    {
        lat: 22.287486,
        lng: 114.01897800000002,
    },
    {
        lat: 22.287622,
        lng: 114.018981,
    },
    {
        lat: 22.287683999999995,
        lng: 114.018967,
    },
    {
        lat: 22.287761,
        lng: 114.018932,
    },
    {
        lat: 22.287808,
        lng: 114.018914,
    },
    {
        lat: 22.2879,
        lng: 114.018914,
    },
    {
        lat: 22.288037,
        lng: 114.018911,
    },
    {
        lat: 22.288268,
        lng: 114.018908,
    },
    {
        lat: 22.288406,
        lng: 114.018922,
    },
    {
        lat: 22.288511000000003,
        lng: 114.018932,
    },
    {
        lat: 22.28856,
        lng: 114.018932,
    },
    {
        lat: 22.288644999999995,
        lng: 114.018914,
    },
    {
        lat: 22.288701999999997,
        lng: 114.018906,
    },
    {
        lat: 22.288737,
        lng: 114.018911,
    },
    {
        lat: 22.288816,
        lng: 114.018938,
    },
    {
        lat: 22.288858,
        lng: 114.018951,
    },
    {
        lat: 22.288876,
        lng: 114.018932,
    },
    {
        lat: 22.289131,
        lng: 114.018991,
    },
    {
        lat: 22.289528,
        lng: 114.019184,
    },
    {
        lat: 22.289898,
        lng: 114.019418,
    },
    {
        lat: 22.290129,
        lng: 114.019592,
    },
    {
        lat: 22.290427000000005,
        lng: 114.019828,
    },
    {
        lat: 22.290573,
        lng: 114.019941,
    },
    {
        lat: 22.29062,
        lng: 114.019973,
    },
    {
        lat: 22.290655,
        lng: 114.02004,
    },
    {
        lat: 22.290677,
        lng: 114.02010400000002,
    },
    {
        lat: 22.290672,
        lng: 114.020155,
    },
    {
        lat: 22.290652,
        lng: 114.020204,
    },
    {
        lat: 22.29064,
        lng: 114.02026,
    },
    {
        lat: 22.29065,
        lng: 114.020298,
    },
    {
        lat: 22.290674999999997,
        lng: 114.02033,
    },
    {
        lat: 22.290704999999996,
        lng: 114.020397,
    },
    {
        lat: 22.290738999999995,
        lng: 114.020464,
    },
    {
        lat: 22.290739,
        lng: 114.020518,
    },
    {
        lat: 22.290739,
        lng: 114.020574,
    },
    {
        lat: 22.290732,
        lng: 114.020646,
    },
    {
        lat: 22.290712000000003,
        lng: 114.020748,
    },
    {
        lat: 22.290687,
        lng: 114.020821,
    },
    {
        lat: 22.290648,
        lng: 114.020872,
    },
    {
        lat: 22.290583,
        lng: 114.020976,
    },
    {
        lat: 22.290568,
        lng: 114.021035,
    },
    {
        lat: 22.29058,
        lng: 114.021081,
    },
    {
        lat: 22.290605,
        lng: 114.021121,
    },
    {
        lat: 22.290638,
        lng: 114.02114000000002,
    },
    {
        lat: 22.29069,
        lng: 114.021153,
    },
    {
        lat: 22.29072,
        lng: 114.021153,
    },
    {
        lat: 22.290767,
        lng: 114.021116,
    },
    {
        lat: 22.290839,
        lng: 114.021048,
    },
    {
        lat: 22.290871,
        lng: 114.02099,
    },
    {
        lat: 22.290908,
        lng: 114.020898,
    },
    {
        lat: 22.290944999999997,
        lng: 114.020775,
    },
    {
        lat: 22.290965,
        lng: 114.020686,
    },
    {
        lat: 22.291,
        lng: 114.020542,
    },
    {
        lat: 22.291035,
        lng: 114.020442,
    },
    {
        lat: 22.291077,
        lng: 114.020311,
    },
    {
        lat: 22.291107000000004,
        lng: 114.020193,
    },
    {
        lat: 22.291161,
        lng: 114.020102,
    },
    {
        lat: 22.291198,
        lng: 114.020051,
    },
    {
        lat: 22.291233,
        lng: 114.020021,
    },
    {
        lat: 22.291263,
        lng: 114.020013,
    },
    {
        lat: 22.291293,
        lng: 114.020029,
    },
    {
        lat: 22.291322999999995,
        lng: 114.020037,
    },
    {
        lat: 22.291355,
        lng: 114.020035,
    },
    {
        lat: 22.291409,
        lng: 114.020029,
    },
    {
        lat: 22.291437,
        lng: 114.019976,
    },
    {
        lat: 22.291457,
        lng: 114.019927,
    },
    {
        lat: 22.291481000000005,
        lng: 114.019898,
    },
    {
        lat: 22.291511000000003,
        lng: 114.019866,
    },
    {
        lat: 22.291519,
        lng: 114.019815,
    },
    {
        lat: 22.291519,
        lng: 114.01978,
    },
    {
        lat: 22.291499,
        lng: 114.01974,
    },
    {
        lat: 22.291469,
        lng: 114.019697,
    },
    {
        lat: 22.291452,
        lng: 114.019646,
    },
    {
        lat: 22.291452,
        lng: 114.019589,
    },
    {
        lat: 22.291476000000003,
        lng: 114.019536,
    },
    {
        lat: 22.291526,
        lng: 114.019461,
    },
    {
        lat: 22.291588,
        lng: 114.019383,
    },
    {
        lat: 22.291625,
        lng: 114.01934,
    },
    {
        lat: 22.291685,
        lng: 114.019294,
    },
    {
        lat: 22.291731999999996,
        lng: 114.019268,
    },
    {
        lat: 22.291821,
        lng: 114.01923800000002,
    },
    {
        lat: 22.291926,
        lng: 114.019198,
    },
    {
        lat: 22.292027,
        lng: 114.019176,
    },
    {
        lat: 22.292228,
        lng: 114.019144,
    },
    {
        lat: 22.292859,
        lng: 114.019176,
    },
    {
        lat: 22.292928,
        lng: 114.019184,
    },
    {
        lat: 22.292983000000003,
        lng: 114.01923,
    },
    {
        lat: 22.293023000000005,
        lng: 114.019318,
    },
    {
        lat: 22.293057,
        lng: 114.019437,
    },
    {
        lat: 22.293070000000004,
        lng: 114.019506,
    },
    {
        lat: 22.293154000000005,
        lng: 114.01949000000002,
    },
    {
        lat: 22.293281,
        lng: 114.019471,
    },
    {
        lat: 22.293437000000004,
        lng: 114.019493,
    },
    {
        lat: 22.293586,
        lng: 114.019571,
    },
    {
        lat: 22.293698000000003,
        lng: 114.019648,
    },
    {
        lat: 22.293844,
        lng: 114.019782,
    },
    {
        lat: 22.293986000000004,
        lng: 114.019938,
    },
    {
        lat: 22.29406,
        lng: 114.020037,
    },
    {
        lat: 22.294095,
        lng: 114.020096,
    },
    {
        lat: 22.294107,
        lng: 114.020155,
    },
    {
        lat: 22.2941,
        lng: 114.020214,
    },
    {
        lat: 22.294077000000005,
        lng: 114.020295,
    },
    {
        lat: 22.294057,
        lng: 114.020351,
    },
    {
        lat: 22.293382,
        lng: 114.021239,
    },
    {
        lat: 22.293368,
        lng: 114.021266,
    },
    {
        lat: 22.293373,
        lng: 114.021293,
    },
    {
        lat: 22.293385,
        lng: 114.021317,
    },
    {
        lat: 22.293392,
        lng: 114.021341,
    },
    {
        lat: 22.292082,
        lng: 114.023044,
    },
    {
        lat: 22.292065,
        lng: 114.023068,
    },
    {
        lat: 22.291963,
        lng: 114.02313,
    },
    {
        lat: 22.291551,
        lng: 114.023693,
    },
    {
        lat: 22.291511,
        lng: 114.023774,
    },
    {
        lat: 22.291499,
        lng: 114.023833,
    },
    {
        lat: 22.291499,
        lng: 114.023921,
    },
    {
        lat: 22.291511000000003,
        lng: 114.023983,
    },
    {
        lat: 22.291529,
        lng: 114.02404500000002,
    },
    {
        lat: 22.291568,
        lng: 114.024104,
    },
    {
        lat: 22.291623,
        lng: 114.024163,
    },
    {
        lat: 22.291731999999996,
        lng: 114.024254,
    },
    {
        lat: 22.291863999999997,
        lng: 114.024369,
    },
    {
        lat: 22.292103999999995,
        lng: 114.024554,
    },
    {
        lat: 22.292174,
        lng: 114.024605,
    },
    {
        lat: 22.292243,
        lng: 114.024664,
    },
    {
        lat: 22.292305,
        lng: 114.024691,
    },
    {
        lat: 22.292407,
        lng: 114.024728,
    },
    {
        lat: 22.292468999999997,
        lng: 114.024734,
    },
    {
        lat: 22.292583,
        lng: 114.024731,
    },
    {
        lat: 22.2927,
        lng: 114.024712,
    },
    {
        lat: 22.292814,
        lng: 114.024675,
    },
    {
        lat: 22.292946000000004,
        lng: 114.024632,
    },
    {
        lat: 22.293014999999997,
        lng: 114.024568,
    },
    {
        lat: 22.293082,
        lng: 114.024519,
    },
    {
        lat: 22.293126999999995,
        lng: 114.024466,
    },
    {
        lat: 22.293235999999997,
        lng: 114.024361,
    },
    {
        lat: 22.293323,
        lng: 114.024256,
    },
    {
        lat: 22.293417,
        lng: 114.024136,
    },
    {
        lat: 22.293462,
        lng: 114.024077,
    },
    {
        lat: 22.293494,
        lng: 114.024079,
    },
    {
        lat: 22.293526,
        lng: 114.024104,
    },
    {
        lat: 22.293559,
        lng: 114.02412,
    },
    {
        lat: 22.293600999999995,
        lng: 114.02413300000002,
    },
    {
        lat: 22.293646,
        lng: 114.02413,
    },
    {
        lat: 22.293684999999996,
        lng: 114.02413,
    },
    {
        lat: 22.293735,
        lng: 114.02412,
    },
    {
        lat: 22.293772,
        lng: 114.024104,
    },
    {
        lat: 22.293788999999997,
        lng: 114.024077,
    },
    {
        lat: 22.293819000000003,
        lng: 114.024023,
    },
    {
        lat: 22.293859000000005,
        lng: 114.023951,
    },
    {
        lat: 22.293904,
        lng: 114.023878,
    },
    {
        lat: 22.293971,
        lng: 114.023811,
    },
    {
        lat: 22.294045000000004,
        lng: 114.023763,
    },
    {
        lat: 22.294107,
        lng: 114.023725,
    },
    {
        lat: 22.294179,
        lng: 114.023699,
    },
    {
        lat: 22.294268,
        lng: 114.023674,
    },
    {
        lat: 22.294384999999995,
        lng: 114.023661,
    },
    {
        lat: 22.294477000000004,
        lng: 114.023685,
    },
    {
        lat: 22.294591,
        lng: 114.023739,
    },
    {
        lat: 22.294698000000004,
        lng: 114.023811,
    },
    {
        lat: 22.294775000000005,
        lng: 114.023932,
    },
    {
        lat: 22.294832,
        lng: 114.024061,
    },
    {
        lat: 22.294863999999997,
        lng: 114.024176,
    },
    {
        lat: 22.294859,
        lng: 114.024281,
    },
    {
        lat: 22.294834,
        lng: 114.024382,
    },
    {
        lat: 22.294819,
        lng: 114.024439,
    },
    {
        lat: 22.294771999999995,
        lng: 114.024549,
    },
    {
        lat: 22.294720000000005,
        lng: 114.024632,
    },
    {
        lat: 22.294659999999997,
        lng: 114.02473700000002,
    },
    {
        lat: 22.294606000000005,
        lng: 114.024814,
    },
    {
        lat: 22.294551,
        lng: 114.024879,
    },
    {
        lat: 22.294504,
        lng: 114.024919,
    },
    {
        lat: 22.294005,
        lng: 114.025294,
    },
    {
        lat: 22.293956,
        lng: 114.025348,
    },
    {
        lat: 22.293931,
        lng: 114.025415,
    },
    {
        lat: 22.293918,
        lng: 114.025512,
    },
    {
        lat: 22.293908,
        lng: 114.02567,
    },
    {
        lat: 22.293894,
        lng: 114.02586,
    },
    {
        lat: 22.293884,
        lng: 114.025986,
    },
    {
        lat: 22.293878999999997,
        lng: 114.026032,
    },
    {
        lat: 22.293861,
        lng: 114.026075,
    },
    {
        lat: 22.293839,
        lng: 114.026102,
    },
    {
        lat: 22.291881000000004,
        lng: 114.027489,
    },
    {
        lat: 22.291839,
        lng: 114.027515,
    },
    {
        lat: 22.291754,
        lng: 114.02755600000002,
    },
    {
        lat: 22.291709999999995,
        lng: 114.027577,
    },
    {
        lat: 22.291663,
        lng: 114.027582,
    },
    {
        lat: 22.29163,
        lng: 114.027572,
    },
    {
        lat: 22.291583,
        lng: 114.027553,
    },
    {
        lat: 22.291179,
        lng: 114.027306,
    },
    {
        lat: 22.291151,
        lng: 114.027279,
    },
    {
        lat: 22.291124,
        lng: 114.027236,
    },
    {
        lat: 22.291112,
        lng: 114.027183,
    },
    {
        lat: 22.291099000000003,
        lng: 114.027137,
    },
    {
        lat: 22.291424000000003,
        lng: 114.024932,
    },
    {
        lat: 22.291433999999995,
        lng: 114.02486,
    },
    {
        lat: 22.291437,
        lng: 114.024828,
    },
    {
        lat: 22.291424000000003,
        lng: 114.024796,
    },
    {
        lat: 22.291404,
        lng: 114.02478000000002,
    },
    {
        lat: 22.291380000000004,
        lng: 114.024774,
    },
    {
        lat: 22.291342,
        lng: 114.02479,
    },
    {
        lat: 22.291305,
        lng: 114.024822,
    },
    {
        lat: 22.291278,
        lng: 114.024876,
    },
    {
        lat: 22.29092,
        lng: 114.027105,
    },
    {
        lat: 22.290923000000003,
        lng: 114.027194,
    },
    {
        lat: 22.290926,
        lng: 114.027282,
    },
    {
        lat: 22.290952999999995,
        lng: 114.027338,
    },
    {
        lat: 22.290978000000003,
        lng: 114.02737600000002,
    },
    {
        lat: 22.291022,
        lng: 114.027413,
    },
    {
        lat: 22.291047,
        lng: 114.027446,
    },
    {
        lat: 22.29167,
        lng: 114.027813,
    },
    {
        lat: 22.291707,
        lng: 114.027826,
    },
    {
        lat: 22.291737000000005,
        lng: 114.027829,
    },
    {
        lat: 22.291779,
        lng: 114.027805,
    },
    {
        lat: 22.291931,
        lng: 114.02773,
    },
    {
        lat: 22.291965000000005,
        lng: 114.027687,
    },
    {
        lat: 22.293896000000004,
        lng: 114.026292,
    },
    {
        lat: 22.293936,
        lng: 114.026268,
    },
    {
        lat: 22.293968,
        lng: 114.026271,
    },
    {
        lat: 22.29399,
        lng: 114.026298,
    },
    {
        lat: 22.294003,
        lng: 114.026343,
    },
    {
        lat: 22.294043,
        lng: 114.026416,
    },
    {
        lat: 22.294101999999995,
        lng: 114.026518,
    },
    {
        lat: 22.294139,
        lng: 114.02659,
    },
    {
        lat: 22.294158999999997,
        lng: 114.026617,
    },
    {
        lat: 22.294194,
        lng: 114.026625,
    },
    {
        lat: 22.294226,
        lng: 114.026611,
    },
    {
        lat: 22.294254,
        lng: 114.026579,
    },
    {
        lat: 22.294281,
        lng: 114.026528,
    },
    {
        lat: 22.294319999999995,
        lng: 114.026477,
    },
    {
        lat: 22.294368,
        lng: 114.026426,
    },
    {
        lat: 22.294407000000003,
        lng: 114.026384,
    },
    {
        lat: 22.294445000000003,
        lng: 114.026343,
    },
    {
        lat: 22.294472,
        lng: 114.026324,
    },
    {
        lat: 22.294509,
        lng: 114.026314,
    },
    {
        lat: 22.294554,
        lng: 114.0263,
    },
    {
        lat: 22.294586,
        lng: 114.02626,
    },
    {
        lat: 22.294621,
        lng: 114.026201,
    },
    {
        lat: 22.294648,
        lng: 114.02616600000002,
    },
    {
        lat: 22.294690000000003,
        lng: 114.026145,
    },
    {
        lat: 22.294732000000003,
        lng: 114.026118,
    },
    {
        lat: 22.294765,
        lng: 114.026086,
    },
    {
        lat: 22.294779999999996,
        lng: 114.026035,
    },
    {
        lat: 22.294794,
        lng: 114.025984,
    },
    {
        lat: 22.294789999999995,
        lng: 114.025933,
    },
    {
        lat: 22.2948,
        lng: 114.025858,
    },
    {
        lat: 22.294819,
        lng: 114.025767,
    },
    {
        lat: 22.294859,
        lng: 114.025721,
    },
    {
        lat: 22.294911,
        lng: 114.025673,
    },
    {
        lat: 22.294963,
        lng: 114.025646,
    },
    {
        lat: 22.294998000000003,
        lng: 114.025614,
    },
    {
        lat: 22.295043,
        lng: 114.025568,
    },
    {
        lat: 22.29509,
        lng: 114.025539,
    },
    {
        lat: 22.295179,
        lng: 114.025488,
    },
    {
        lat: 22.295241000000004,
        lng: 114.02548,
    },
    {
        lat: 22.295303,
        lng: 114.02548,
    },
    {
        lat: 22.295378000000003,
        lng: 114.025482,
    },
    {
        lat: 22.295437,
        lng: 114.02549,
    },
    {
        lat: 22.295480000000005,
        lng: 114.025512,
    },
    {
        lat: 22.295514,
        lng: 114.025552,
    },
    {
        lat: 22.295566,
        lng: 114.025568,
    },
    {
        lat: 22.295604000000004,
        lng: 114.025573,
    },
    {
        lat: 22.29568,
        lng: 114.025571,
    },
    {
        lat: 22.29576,
        lng: 114.02553,
    },
    {
        lat: 22.295842000000004,
        lng: 114.025504,
    },
    {
        lat: 22.295940999999996,
        lng: 114.025488,
    },
    {
        lat: 22.296025,
        lng: 114.025485,
    },
    {
        lat: 22.296115,
        lng: 114.025493,
    },
    {
        lat: 22.296189,
        lng: 114.025501,
    },
    {
        lat: 22.296291,
        lng: 114.025552,
    },
    {
        lat: 22.296387999999997,
        lng: 114.025619,
    },
    {
        lat: 22.29649,
        lng: 114.025686,
    },
    {
        lat: 22.296584,
        lng: 114.025745,
    },
    {
        lat: 22.296676,
        lng: 114.025801,
    },
    {
        lat: 22.29671,
        lng: 114.02581800000002,
    },
    {
        lat: 22.296758,
        lng: 114.025801,
    },
    {
        lat: 22.296802,
        lng: 114.02577700000002,
    },
    {
        lat: 22.296832,
        lng: 114.025767,
    },
    {
        lat: 22.296879,
        lng: 114.025788,
    },
    {
        lat: 22.296944,
        lng: 114.025823,
    },
    {
        lat: 22.297001,
        lng: 114.025844,
    },
    {
        lat: 22.29706,
        lng: 114.025847,
    },
    {
        lat: 22.297117,
        lng: 114.025847,
    },
    {
        lat: 22.297187,
        lng: 114.025826,
    },
    {
        lat: 22.297244,
        lng: 114.025807,
    },
    {
        lat: 22.297286,
        lng: 114.025785,
    },
    {
        lat: 22.297321,
        lng: 114.02575,
    },
    {
        lat: 22.297353,
        lng: 114.025734,
    },
    {
        lat: 22.297398,
        lng: 114.025713,
    },
    {
        lat: 22.297425000000004,
        lng: 114.025678,
    },
    {
        lat: 22.297465,
        lng: 114.02564,
    },
    {
        lat: 22.297497,
        lng: 114.025627,
    },
    {
        lat: 22.297534,
        lng: 114.025632,
    },
    {
        lat: 22.297572,
        lng: 114.02564,
    },
    {
        lat: 22.297604,
        lng: 114.025635,
    },
    {
        lat: 22.297636,
        lng: 114.025619,
    },
    {
        lat: 22.297661000000005,
        lng: 114.025571,
    },
    {
        lat: 22.297666,
        lng: 114.025522,
    },
    {
        lat: 22.297671,
        lng: 114.025466,
    },
    {
        lat: 22.297683,
        lng: 114.025396,
    },
    {
        lat: 22.297708,
        lng: 114.025364,
    },
    {
        lat: 22.297743,
        lng: 114.02534500000002,
    },
    {
        lat: 22.297782,
        lng: 114.02534500000002,
    },
    {
        lat: 22.297822,
        lng: 114.02538800000002,
    },
    {
        lat: 22.297857000000004,
        lng: 114.02538800000002,
    },
    {
        lat: 22.297867,
        lng: 114.02534500000002,
    },
    {
        lat: 22.297862,
        lng: 114.025265,
    },
    {
        lat: 22.297862,
        lng: 114.02519,
    },
    {
        lat: 22.297862,
        lng: 114.025131,
    },
    {
        lat: 22.297852,
        lng: 114.025008,
    },
    {
        lat: 22.297857000000004,
        lng: 114.024927,
    },
    {
        lat: 22.297897,
        lng: 114.024868,
    },
    {
        lat: 22.297951,
        lng: 114.024814,
    },
    {
        lat: 22.298025999999997,
        lng: 114.024766,
    },
    {
        lat: 22.29813,
        lng: 114.024707,
    },
    {
        lat: 22.298224,
        lng: 114.024675,
    },
    {
        lat: 22.298333,
        lng: 114.024648,
    },
    {
        lat: 22.298428000000005,
        lng: 114.024621,
    },
    {
        lat: 22.298512,
        lng: 114.024627,
    },
    {
        lat: 22.298586000000004,
        lng: 114.0246,
    },
    {
        lat: 22.298661000000003,
        lng: 114.024594,
    },
    {
        lat: 22.298745000000004,
        lng: 114.024589,
    },
    {
        lat: 22.298815,
        lng: 114.02461,
    },
    {
        lat: 22.298884000000005,
        lng: 114.024621,
    },
    {
        lat: 22.298954,
        lng: 114.024605,
    },
    {
        lat: 22.299043,
        lng: 114.024605,
    },
    {
        lat: 22.299108,
        lng: 114.024605,
    },
    {
        lat: 22.299152,
        lng: 114.024568,
    },
    {
        lat: 22.299166999999997,
        lng: 114.024498,
    },
    {
        lat: 22.299132000000004,
        lng: 114.024417,
    },
    {
        lat: 22.299088,
        lng: 114.024369,
    },
    {
        lat: 22.299053000000004,
        lng: 114.024273,
    },
    {
        lat: 22.299018,
        lng: 114.024181,
    },
    {
        lat: 22.298998,
        lng: 114.024079,
    },
    {
        lat: 22.298993999999997,
        lng: 114.023999,
    },
    {
        lat: 22.298993999999997,
        lng: 114.023918,
    },
    {
        lat: 22.298959,
        lng: 114.02386,
    },
    {
        lat: 22.298904,
        lng: 114.023795,
    },
    {
        lat: 22.298844999999996,
        lng: 114.023758,
    },
    {
        lat: 22.298774999999996,
        lng: 114.023731,
    },
    {
        lat: 22.298696,
        lng: 114.023661,
    },
    {
        lat: 22.298621000000004,
        lng: 114.023602,
    },
    {
        lat: 22.298467,
        lng: 114.023473,
    },
    {
        lat: 22.298368,
        lng: 114.023366,
    },
    {
        lat: 22.298309,
        lng: 114.023275,
    },
    {
        lat: 22.298229,
        lng: 114.023221,
    },
    {
        lat: 22.298135,
        lng: 114.023162,
    },
    {
        lat: 22.29805,
        lng: 114.023119,
    },
    {
        lat: 22.297971,
        lng: 114.02313,
    },
    {
        lat: 22.297877,
        lng: 114.023141,
    },
    {
        lat: 22.297817,
        lng: 114.023103,
    },
    {
        lat: 22.297748,
        lng: 114.02306,
    },
    {
        lat: 22.297647999999995,
        lng: 114.02295800000002,
    },
    {
        lat: 22.297564,
        lng: 114.022819,
    },
    {
        lat: 22.297495,
        lng: 114.022738,
    },
    {
        lat: 22.29741,
        lng: 114.02261,
    },
    {
        lat: 22.297385,
        lng: 114.022551,
    },
    {
        lat: 22.297356,
        lng: 114.022406,
    },
    {
        lat: 22.297316,
        lng: 114.022245,
    },
    {
        lat: 22.297301,
        lng: 114.022127,
    },
    {
        lat: 22.297281,
        lng: 114.022046,
    },
    {
        lat: 22.297266,
        lng: 114.021977,
    },
    {
        lat: 22.297226999999996,
        lng: 114.021928,
    },
    {
        lat: 22.297161999999997,
        lng: 114.021864,
    },
    {
        lat: 22.297102,
        lng: 114.02183200000002,
    },
    {
        lat: 22.297043,
        lng: 114.021784,
    },
    {
        lat: 22.297018,
        lng: 114.021735,
    },
    {
        lat: 22.297003,
        lng: 114.021671,
    },
    {
        lat: 22.297033000000003,
        lng: 114.021601,
    },
    {
        lat: 22.297053,
        lng: 114.021542,
    },
    {
        lat: 22.297038,
        lng: 114.021494,
    },
    {
        lat: 22.296581,
        lng: 114.020947,
    },
    {
        lat: 22.296209,
        lng: 114.020501,
    },
    {
        lat: 22.295723,
        lng: 114.019986,
    },
    {
        lat: 22.295708,
        lng: 114.01979900000002,
    },
    {
        lat: 22.296189,
        lng: 114.019284,
    },
    {
        lat: 22.296178999999995,
        lng: 114.01916,
    },
    {
        lat: 22.295817,
        lng: 114.017835,
    },
    {
        lat: 22.296631,
        lng: 114.017562,
    },
    {
        lat: 22.29679,
        lng: 114.01812,
    },
    {
        lat: 22.296899,
        lng: 114.018087,
    },
    {
        lat: 22.296879,
        lng: 114.017969,
    },
    {
        lat: 22.296978,
        lng: 114.017948,
    },
    {
        lat: 22.296844,
        lng: 114.017336,
    },
    {
        lat: 22.296869000000004,
        lng: 114.017272,
    },
    {
        lat: 22.2968,
        lng: 114.016956,
    },
    {
        lat: 22.296864000000003,
        lng: 114.016821,
    },
    {
        lat: 22.296626,
        lng: 114.016151,
    },
    {
        lat: 22.296656,
        lng: 114.016108,
    },
    {
        lat: 22.29669,
        lng: 114.016065,
    },
    {
        lat: 22.296715,
        lng: 114.01599,
    },
    {
        lat: 22.29678,
        lng: 114.015952,
    },
    {
        lat: 22.296934,
        lng: 114.015877,
    },
    {
        lat: 22.297102,
        lng: 114.015791,
    },
    {
        lat: 22.297306,
        lng: 114.015706,
    },
    {
        lat: 22.297435,
        lng: 114.01564100000002,
    },
    {
        lat: 22.297579,
        lng: 114.015588,
    },
    {
        lat: 22.297683,
        lng: 114.015566,
    },
    {
        lat: 22.297946,
        lng: 114.015507,
    },
    {
        lat: 22.298149999999996,
        lng: 114.01547,
    },
    {
        lat: 22.298328000000005,
        lng: 114.015448,
    },
    {
        lat: 22.298492,
        lng: 114.015421,
    },
    {
        lat: 22.298661,
        lng: 114.015421,
    },
    {
        lat: 22.29884,
        lng: 114.01541,
    },
    {
        lat: 22.299018,
        lng: 114.015405,
    },
    {
        lat: 22.299172,
        lng: 114.015416,
    },
    {
        lat: 22.299316,
        lng: 114.015416,
    },
    {
        lat: 22.29947,
        lng: 114.01541,
    },
    {
        lat: 22.299594,
        lng: 114.01541,
    },
    {
        lat: 22.299748,
        lng: 114.015443,
    },
    {
        lat: 22.299917,
        lng: 114.015486,
    },
    {
        lat: 22.300056,
        lng: 114.015523,
    },
    {
        lat: 22.300155000000004,
        lng: 114.015566,
    },
    {
        lat: 22.300229,
        lng: 114.015609,
    },
    {
        lat: 22.300274,
        lng: 114.015673,
    },
    {
        lat: 22.300314,
        lng: 114.01577000000002,
    },
    {
        lat: 22.300318999999998,
        lng: 114.015861,
    },
    {
        lat: 22.300314000000004,
        lng: 114.015974,
    },
    {
        lat: 22.300304,
        lng: 114.016113,
    },
    {
        lat: 22.300284,
        lng: 114.016258,
    },
    {
        lat: 22.300264,
        lng: 114.016387,
    },
    {
        lat: 22.300264,
        lng: 114.016505,
    },
    {
        lat: 22.300249,
        lng: 114.016623,
    },
    {
        lat: 22.300244,
        lng: 114.016746,
    },
    {
        lat: 22.300244,
        lng: 114.01687,
    },
    {
        lat: 22.300249,
        lng: 114.016977,
    },
    {
        lat: 22.300264,
        lng: 114.017068,
    },
    {
        lat: 22.300274000000005,
        lng: 114.017159,
    },
    {
        lat: 22.300284,
        lng: 114.017256,
    },
    {
        lat: 22.300289,
        lng: 114.01736900000002,
    },
    {
        lat: 22.300294,
        lng: 114.017454,
    },
    {
        lat: 22.300309,
        lng: 114.01753,
    },
    {
        lat: 22.300344000000003,
        lng: 114.017621,
    },
    {
        lat: 22.300383,
        lng: 114.017755,
    },
    {
        lat: 22.300383,
        lng: 114.017835,
    },
    {
        lat: 22.300378,
        lng: 114.017916,
    },
    {
        lat: 22.300398,
        lng: 114.017991,
    },
    {
        lat: 22.300433,
        lng: 114.018061,
    },
    {
        lat: 22.300477999999995,
        lng: 114.01813,
    },
    {
        lat: 22.300502,
        lng: 114.018211,
    },
    {
        lat: 22.300531999999997,
        lng: 114.018297,
    },
    {
        lat: 22.300562,
        lng: 114.018377,
    },
    {
        lat: 22.300577,
        lng: 114.01849,
    },
    {
        lat: 22.300592000000005,
        lng: 114.018586,
    },
    {
        lat: 22.300635999999997,
        lng: 114.018694,
    },
    {
        lat: 22.300701,
        lng: 114.018817,
    },
    {
        lat: 22.30074,
        lng: 114.018908,
    },
    {
        lat: 22.300805,
        lng: 114.01901,
    },
    {
        lat: 22.30088,
        lng: 114.01908,
    },
    {
        lat: 22.300974,
        lng: 114.019144,
    },
    {
        lat: 22.301019000000004,
        lng: 114.019241,
    },
    {
        lat: 22.301083,
        lng: 114.019353,
    },
    {
        lat: 22.301128,
        lng: 114.019477,
    },
    {
        lat: 22.301162,
        lng: 114.019589,
    },
    {
        lat: 22.301162,
        lng: 114.019643,
    },
    {
        lat: 22.301148,
        lng: 114.019718,
    },
    {
        lat: 22.301143,
        lng: 114.019788,
    },
    {
        lat: 22.301167,
        lng: 114.019842,
    },
    {
        lat: 22.301192,
        lng: 114.019906,
    },
    {
        lat: 22.301217,
        lng: 114.019976,
    },
    {
        lat: 22.301232,
        lng: 114.020035,
    },
    {
        lat: 22.301277,
        lng: 114.020115,
    },
    {
        lat: 22.301282,
        lng: 114.02019,
    },
    {
        lat: 22.301282,
        lng: 114.020255,
    },
    {
        lat: 22.301266999999996,
        lng: 114.02035600000002,
    },
    {
        lat: 22.301237000000004,
        lng: 114.02044800000002,
    },
    {
        lat: 22.301221999999996,
        lng: 114.020507,
    },
    {
        lat: 22.301226999999997,
        lng: 114.020576,
    },
    {
        lat: 22.301227,
        lng: 114.020652,
    },
    {
        lat: 22.301252,
        lng: 114.0207,
    },
    {
        lat: 22.301296,
        lng: 114.0207,
    },
    {
        lat: 22.301331,
        lng: 114.020662,
    },
    {
        lat: 22.301376,
        lng: 114.020619,
    },
    {
        lat: 22.301435,
        lng: 114.020576,
    },
    {
        lat: 22.301505,
        lng: 114.020544,
    },
    {
        lat: 22.301569,
        lng: 114.020523,
    },
    {
        lat: 22.301629,
        lng: 114.020475,
    },
    {
        lat: 22.301684,
        lng: 114.020437,
    },
    {
        lat: 22.301728,
        lng: 114.0204,
    },
    {
        lat: 22.301753000000005,
        lng: 114.020351,
    },
    {
        lat: 22.301793,
        lng: 114.020308,
    },
    {
        lat: 22.301803000000003,
        lng: 114.020238,
    },
    {
        lat: 22.301803,
        lng: 114.020153,
    },
    {
        lat: 22.301763000000005,
        lng: 114.020099,
    },
    {
        lat: 22.301713000000003,
        lng: 114.020062,
    },
    {
        lat: 22.301654,
        lng: 114.020045,
    },
    {
        lat: 22.301609000000003,
        lng: 114.019997,
    },
    {
        lat: 22.301588999999996,
        lng: 114.019906,
    },
    {
        lat: 22.301574,
        lng: 114.019809,
    },
    {
        lat: 22.301574,
        lng: 114.019745,
    },
    {
        lat: 22.301589,
        lng: 114.019675,
    },
    {
        lat: 22.301614000000004,
        lng: 114.019611,
    },
    {
        lat: 22.301703,
        lng: 114.019471,
    },
    {
        lat: 22.301788,
        lng: 114.019337,
    },
    {
        lat: 22.301902,
        lng: 114.019246,
    },
    {
        lat: 22.301981000000005,
        lng: 114.019209,
    },
    {
        lat: 22.302154999999996,
        lng: 114.01916,
    },
    {
        lat: 22.302299,
        lng: 114.019139,
    },
    {
        lat: 22.302349,
        lng: 114.01916,
    },
    {
        lat: 22.302383,
        lng: 114.019257,
    },
    {
        lat: 22.302418,
        lng: 114.019337,
    },
    {
        lat: 22.302442999999997,
        lng: 114.019423,
    },
    {
        lat: 22.302497999999996,
        lng: 114.019482,
    },
    {
        lat: 22.302562,
        lng: 114.01954100000002,
    },
    {
        lat: 22.302612,
        lng: 114.019681,
    },
    {
        lat: 22.302670999999997,
        lng: 114.01982,
    },
    {
        lat: 22.302731000000005,
        lng: 114.019927,
    },
    {
        lat: 22.302775000000004,
        lng: 114.019954,
    },
    {
        lat: 22.302815,
        lng: 114.019933,
    },
    {
        lat: 22.302845,
        lng: 114.019863,
    },
    {
        lat: 22.302845,
        lng: 114.019772,
    },
    {
        lat: 22.302815,
        lng: 114.019702,
    },
    {
        lat: 22.30282,
        lng: 114.019627,
    },
    {
        lat: 22.302825,
        lng: 114.019552,
    },
    {
        lat: 22.30285,
        lng: 114.019482,
    },
    {
        lat: 22.30289,
        lng: 114.019445,
    },
    {
        lat: 22.302949,
        lng: 114.019439,
    },
    {
        lat: 22.302983999999995,
        lng: 114.019407,
    },
    {
        lat: 22.302959,
        lng: 114.018983,
    },
    {
        lat: 22.302914,
        lng: 114.018592,
    },
    {
        lat: 22.30289,
        lng: 114.018264,
    },
    {
        lat: 22.302914,
        lng: 114.018023,
    },
    {
        lat: 22.302959,
        lng: 114.017996,
    },
    {
        lat: 22.303004000000005,
        lng: 114.01797500000002,
    },
    {
        lat: 22.303053,
        lng: 114.017916,
    },
    {
        lat: 22.303123000000003,
        lng: 114.017808,
    },
    {
        lat: 22.303197,
        lng: 114.017664,
    },
    {
        lat: 22.303252,
        lng: 114.017519,
    },
    {
        lat: 22.303302,
        lng: 114.017342,
    },
    {
        lat: 22.303351,
        lng: 114.017245,
    },
    {
        lat: 22.303416,
        lng: 114.017159,
    },
    {
        lat: 22.30346,
        lng: 114.017127,
    },
    {
        lat: 22.30344,
        lng: 114.017084,
    },
    {
        lat: 22.303406,
        lng: 114.01702,
    },
    {
        lat: 22.303406,
        lng: 114.016939,
    },
    {
        lat: 22.303465,
        lng: 114.016703,
    },
    {
        lat: 22.30356,
        lng: 114.016408,
    },
    {
        lat: 22.303654,
        lng: 114.016151,
    },
    {
        lat: 22.303753,
        lng: 114.015968,
    },
    {
        lat: 22.303842,
        lng: 114.01585,
    },
    {
        lat: 22.303917,
        lng: 114.015786,
    },
    {
        lat: 22.304006,
        lng: 114.015754,
    },
    {
        lat: 22.30615,
        lng: 114.015588,
    },
    {
        lat: 22.306313999999997,
        lng: 114.015936,
    },
    {
        lat: 22.305828000000005,
        lng: 114.016403,
    },
    {
        lat: 22.306026,
        lng: 114.016923,
    },
    {
        lat: 22.306736,
        lng: 114.016848,
    },
    {
        lat: 22.306964000000004,
        lng: 114.017438,
    },
    {
        lat: 22.309773,
        lng: 114.01724000000002,
    },
    {
        lat: 22.309857999999995,
        lng: 114.017331,
    },
    {
        lat: 22.309997,
        lng: 114.017433,
    },
    {
        lat: 22.310141,
        lng: 114.017487,
    },
    {
        lat: 22.310273999999996,
        lng: 114.017648,
    },
    {
        lat: 22.310523,
        lng: 114.01828000000002,
    },
    {
        lat: 22.310582,
        lng: 114.018618,
    },
];
exports.defaultStyleDefinition = {
    dbBound: {
        strokeColor: '#8f4d4d',
        strokeWeight: 2,
        strokeOpacity: 0.5,
        fillColor: '#000000',
        fillOpacity: 0.1,
        fillOutside: true,
    },
    developmentBound: {
        strokeColor: '#085963',
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillOpacity: 0.01,
    },
    routeLine: {
        strokeWeight: 4,
        strokeColor: '#3999c6',
        strokeOpacity: 0.5,
    },
};
